// Syvah Polish JS — round 3 (May 21 2026)
// 1. Mobile sticky Add-to-Cart on PDP
// 2. Breadcrumbs injection on PDP if missing
(function(){
  'use strict';
  
  function isMobile() { return window.innerWidth <= 749; }
  function isPDP() { return document.body.classList.contains('template-product') || /^\/products\//.test(location.pathname); }
  
  // ===== Mobile sticky Add to Cart =====
  function buildStickyCart() {
    if (!isPDP() || !isMobile()) return;
    if (document.querySelector('.product-form-sticky-mobile')) return;
    
    var origForm = document.querySelector('form[action*="/cart/add"], product-form, .product-form');
    if (!origForm) return;
    var origBtn = origForm.querySelector('button[name="add"], button[type="submit"]');
    if (!origBtn) return;
    var priceEl = document.querySelector('.price__container .price-item--sale, .price__container .price-item--last:not(.price-item--regular), .price-item--regular');
    var priceText = priceEl ? priceEl.textContent.trim() : '';
    var titleEl = document.querySelector('.product__title, h1.product__title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    
    var sticky = document.createElement('div');
    sticky.className = 'product-form-sticky-mobile';
    sticky.setAttribute('aria-label', 'Quick add to cart');
    sticky.innerHTML = '<div class="price" aria-label="Price">' + priceText + '</div>' +
      '<button type="button" aria-label="Add ' + title.replace(/"/g,'') + ' to cart">Add to cart</button>';
    
    sticky.querySelector('button').addEventListener('click', function() {
      // Trigger the original form's submit button
      var actualBtn = origForm.querySelector('button[name="add"]');
      if (actualBtn) {
        // Scroll to product form briefly so user sees it then submit
        actualBtn.click();
      }
    });
    
    // Show only after user scrolls past hero area
    sticky.style.display = 'none';
    document.body.appendChild(sticky);
    
    var showThreshold = 400;
    window.addEventListener('scroll', function() {
      if (!isMobile()) { sticky.style.display = 'none'; return; }
      sticky.style.display = window.scrollY > showThreshold ? 'flex' : 'none';
    }, { passive: true });
  }
  
  // ===== Breadcrumbs injection =====
  function buildBreadcrumbs() {
    if (!isPDP()) return;
    if (document.querySelector('.syvah-breadcrumbs, .breadcrumbs, nav[aria-label="breadcrumb"]')) return;
    
    var titleEl = document.querySelector('.product__title, h1.product__title');
    if (!titleEl) return;
    var productTitle = titleEl.textContent.trim();
    
    // Try to find product type from meta
    var category = 'Shop';
    var categoryUrl = '/collections/all';
    var ld = document.querySelector('script[type="application/ld+json"]');
    if (ld) {
      try {
        var data = JSON.parse(ld.textContent);
        if (data.category) {
          category = data.category;
        }
      } catch(e) {}
    }
    // Map common product types to collection URLs
    var productType = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.type) || '';
    var typeMap = {
      'Home Decor': '/collections/home-decor',
      'Lighting': '/collections/lighting',
      'Health & Beauty': '/collections/beauty',
      'Animals & Pet Supplies': '/collections/pet',
      'Sporting Goods': '/collections/lifestyle-outdoors',
      'Home & Garden': '/collections/home-decor',
      'Toys & Games': '/collections/family-kids',
    };
    if (productType && typeMap[productType]) {
      category = productType;
      categoryUrl = typeMap[productType];
    }
    
    var crumbs = document.createElement('nav');
    crumbs.className = 'syvah-breadcrumbs';
    crumbs.setAttribute('aria-label', 'Breadcrumb');
    crumbs.style.cssText = 'padding: 14px 20px 0 20px; font-size: 13px; color: #5f5f5f;';
    crumbs.innerHTML = '<a href="/" style="color: #5f5f5f; text-decoration: none;">Home</a> ' +
      '<span aria-hidden="true" style="margin: 0 6px;">›</span> ' +
      '<a href="' + categoryUrl + '" style="color: #5f5f5f; text-decoration: none;">' + category + '</a> ' +
      '<span aria-hidden="true" style="margin: 0 6px;">›</span> ' +
      '<span style="color: #1a1a1a;" aria-current="page">' + productTitle + '</span>';
    
    var main = document.querySelector('#MainContent, main');
    if (main) main.insertBefore(crumbs, main.firstChild);
  }
  
  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      buildBreadcrumbs();
      buildStickyCart();
    });
  } else {
    buildBreadcrumbs();
    buildStickyCart();
  }
})();
